import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { AiAgentService } from '../ai-agent.service';
import { AiAgent } from '../ai-agent';

@Component({
    selector: 'app-ai-agent',
    templateUrl: './ai-agent.component.html',
    styleUrls: ['./ai-agent.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class AiAgentComponent implements OnInit {
	categories: any[]=[];
	models: any[]=[];

	constructor(
		private primengConfig: PrimeNGConfig,
		private aiAgentService: AiAgentService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.aiAgent = data.aiAgent,
			this.categories = aiAgentService.categories;
			this.models = aiAgentService.models;
	}

	@Input() aiAgent: AiAgent;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	aiAgentId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'aiAgentId': [],
		'name': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		'category': [],
		'model': [],
		'prompt': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole aiAgent object
		if (this.aiAgent) {
			this.aiAgentId = this.aiAgent.aiAgentId;
			this.fixDates();
			this.form1.patchValue(this.aiAgent);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.aiAgentId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.aiAgentService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.aiAgent = res.data.aiAgent;
						this.doAdd.emit(this.aiAgent);
					},
					(err: any) => {
						console.log('aiAgent-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('aiAgent: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.aiAgentService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.aiAgent = res.data.aiAgent;
						this.doUpdate.emit(this.aiAgent);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.aiAgentService.delete(this.aiAgent.aiAgentId)
				.subscribe(
					(res: any) => {
						console.log('aiAgent-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.aiAgent);
					},
					(err: any) => {
						console.log('aiAgent-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			aiAgentId: [this.aiAgentId],
			name: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			description: [],
			category: [],
			model: [],
			prompt: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.aiAgent.aiAgentDate = moment(this.aiAgent.aiAgentDate).toDate();
	}

	getCategoryName(aiAgent: any) {
		if (aiAgent?.category) {
			const status = this.categories.find((e: any) => e.value == aiAgent.category);
			return status.name;
		}
		else {
			return '';
		}
	}

	getModelName(aiAgent: any) {
		if (aiAgent?.model) {
			const status = this.models.find((e: any) => e.value == aiAgent.model);
			return status.name;
		}
		else {
			return '';
		}
	}
}
